import {
  Building2,
  ClipboardList,
  CreditCard,
  FileCheck,
  type LucideIcon,
  Settings,
  UserCheck,
  UserRound,
} from 'lucide-react';

export interface SidebarItem {
  title: string;
  url?: string;
  icon: LucideIcon;
  isActive?: boolean;
  items?: {
    title: string;
    url: string;
  }[];
  roles?: string[];
}
const sidebarData: SidebarItem[] = [
  {
    title: 'Requests',
    icon: ClipboardList,
    url: '/requests',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'Document Reviews',
    icon: FileCheck,
    url: '/document-reviews',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'TT Reviews',
    icon: CreditCard,
    url: '/tt-reviews',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'Vendors',
    icon: Building2,
    url: '/vendors',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'Customers',
    icon: UserRound,
    url: '/customers',
    roles: ['super_admin', 'admin'],
  },
  {
    title: 'Admins',
    icon: UserCheck,
    url: '/admins',
    roles: ['super_admin'],
  },
  {
    title: 'Settings',
    icon: Settings,
    url: '/settings',
    roles: ['super_admin'],
  },
];

export default sidebarData;
